__turbopack_context__.v({
  "UiAlertDialog": "alertDialog-module__gvkg8W__UiAlertDialog",
});
